import { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import "../styling/sidebar.css";
import "../styling/expensepop.css";
import GetUser from "../services/get-user";
import _ from "lodash";
import { CircularProgress } from "@material-ui/core";
import Alert from "@mui/material/Alert";
import UserService from "../services/user-service";
import Popup from "reactjs-popup";
import ReadSaleCsv from "./fileDataHandlers/readSaleCsv";
import ReadSaleExcel from "./fileDataHandlers/readSaleExcel";

interface SPopupProps {
  stream?: any;
  categories?: any;
  closeSaleModal?: any;
  setReloadAPI?: any;
}

const SPopup: React.FC<SPopupProps> = ({
  stream,
  categories,
  closeSaleModal,
  setReloadAPI,
}) => {
  const [name, setName] = useState("");
  const [openExcelModal, setOpenExcelModal] = useState(false);
  const [usedate, setUseDate] = useState(new Date());
  const [amount, setAmount] = useState<any>("");
  const [cust, setCust] = useState("");
  const [note, setNote] = useState("");
  const [allStreamName, setAllStreamName] = useState([]);
  const [selectedStream, setSelectedStream] = useState("");
  const [totalFees,setTotalFees] = useState<any>("");
  const [isFeeChange,setIsFeeChange] = useState(false);
  const [isOpen,setIsOpen] = useState(false);
  const [allFeeTotal,setAllFeeTotal] =  useState<any>("");
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [loading, setLoading] = useState(false);
  const [typeOfFees, setTypeOfFees] = useState<any>({
    listingFees: 0,
    commision: 0,
    shippingFees: 0,
  });
  const [checkNegativeValue, setCheckNegativeValue] = useState<any>({
    checkListingFees: false,
    checkCommision: false,
    checkShippingFees: false,
  });

  const user = GetUser();
  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  useEffect(() => {
    stream === -1 &&
      UserService.getIncome().then((response) => {
        setAllStreamName(response.data.iname);
      });
  }, []);

  function validateForm() {
    return (
      name.length > 0 &&
      cust.length > 0 &&
      Number(amount) > 0 &&
      Number(typeOfFees.listingFees) >= 0 &&
      Number(typeOfFees.commision) >= 0 &&
      Number(typeOfFees.shippingFees) >= 0
    );
  }

  const countTotalFees = (event) => {
    setIsOpen(true);
    if (event.target.id === "Shipping Fee") {
      setCheckNegativeValue({
        ...checkNegativeValue,
        checkShippingFees: event.target.value < 0,
      });
    }
    if (event.target.id === "Marketplace Fee") {
      setCheckNegativeValue({
        ...checkNegativeValue,
        checkCommision: event.target.value < 0,
      });
    }
    if (event.target.id === "Listing Fees") {
      setCheckNegativeValue({
        ...checkNegativeValue,
        checkListingFees: event.target.value < 0,
      });
    }
    if (event.target.value < 0) {
      setTypeOfFees({
        ...typeOfFees,
        [event.target.name]: 0,
      });
    } else {
      setTypeOfFees({
        ...typeOfFees,
        [event.target.name]: Number(event.target.value),
      });
    }
  };

  const handleChange = (event,key) => {
    const { value } = event.target;
    const [, decimal] = value.split(".");
    if (decimal?.length < 3 || !value.includes(".")) {
      key === "amount" ?  setAmount(value) : setTotalFees(value);;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true)
    try {
      //return axios.post('http://localhost:8080/sale/add_sale', {
      return axios
        .post("https://sotira-back-test.herokuapp.com/sale/add_sale", {
          userID: user.userID,
          name,
          date: usedate,
          amount,
          fee:(!isFeeChange) ? (totalFees === "" ? 0 : totalFees) : (allFeeTotal === "" ? 0 : allFeeTotal),
          customer: cust,
          allfees: typeOfFees,
          note,
          incomeStream: stream === -1 ? Number(selectedStream) + 1 : stream + 1,
        })
        .then((response) => {
          sessionStorage.setItem("option", "sales");
          setLoading(false)
          closeSaleModal(false)
          setReloadAPI((prevState)=>!prevState)
        });
    } catch (e) {
      setLoading(false)
    }
  };

  const disableScroll = (e) => {
    const isFocused = document.activeElement === e.target
    if (isFocused) {
      e.target.blur()
      setTimeout(() => {
        e.target.focus()
      })
    }
  }

  useEffect(()=>{
    const { listingFees, commision, shippingFees } = typeOfFees;
    const updatedTotalFees = (listingFees + commision + shippingFees).toFixed(2);
    setIsFeeChange(true);
    setAllFeeTotal(updatedTotalFees);
  },[typeOfFees])

  return (
    <>
      <div style={{ textAlign: "center" }}>
        <Popup
          trigger={
            <button className="expensecsvbutton"> Import CSV File </button>
          }
          modal
          nested
          className="csv"
        >
          {(close) => (
            <div className="mode">
              <button className="close" onClick={close}>
                &times;
              </button>
              <div className="header"> Import CSV </div>
              <div className="content">
                {" "}
                <ReadSaleCsv
                  stream={stream}
                  categories={categories}
                  setOpenSalesCsvModal={close}  
                  setReloadAPI={setReloadAPI}
                  closeSaleModal={closeSaleModal}
                ></ReadSaleCsv>
                <br />
              </div>
            </div>
          )}
        </Popup>
        <Popup
          trigger={
            <button className="expensecsvbutton"> Import Excel File </button>
          }
          modal
          nested
          className="csv"
        >
          {(close) => (
            <div className="mode">
              <button className="close" onClick={close}>
                &times;
              </button>
              <div className="header"> Import Excel </div>
              <div className="content">
                <ReadSaleExcel
                  stream={stream}
                  categories={categories}
                  // setOpenExcelModal={setOpenExcelModal}
                  setOpenSalesExcelModal={close} 
                  setReloadAPI={setReloadAPI}
                  closeSaleModal={closeSaleModal}
                ></ReadSaleExcel>
                <br />
              </div>
            </div>
          )}
        </Popup>
      </div>

      <div className="or-container">
        <div className="line-1"> </div>
        <span className="or-text"> Or enter manually </span>
        <div className="line-2"> </div>
      </div>
      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="name" className="form-group required">
          <Form.Label className="control-label"> Item Name </Form.Label>
          <Form.Control
            autoFocus
            type="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Form.Group>

        <Form.Group controlId="amount" className="form-group required">
        <Form.Label className="control-label">
           {" "}
            Final Sale Amount ${" "}
          </Form.Label>
          <div className="d-flex">
          <span className="font-currency mr-2 mt-1">$</span>
          <Form.Control
            autoFocus
            onWheel={disableScroll}
            type="number"
            step={0.01}
            value={amount}
            onChange={(e) => handleChange(e,"amount")}
          />
          </div>
        </Form.Group>

        {stream === -1 && (
          <Form.Group controlId="income-stream">
            <Form.Label> Income Stream </Form.Label>
            <select
              id="income-stream"
              className="income-stream-list"
              onChange={(e) => {
                setSelectedStream(e.target.value);
              }}
            >
              {allStreamName.map((item, Key) => (
                <option key={Key} value={Key}>
                  {item}
                </option>
              ))}
            </select>
          </Form.Group>
        )}

        <Form.Group controlId="date">
          <Form.Label> Date Sold </Form.Label>
          <DatePicker
            selected={usedate}
            maxDate={new Date()}
            onChange={(date) => setUseDate(date)}
            showTimeSelect
            dateFormate="Pp"
            className="date-picker-input"
          />
        </Form.Group>

        <Form.Group controlId="cust" className="form-group required">
          <Form.Label className="control-label"> Customer Name </Form.Label>
          <Form.Control
            autoFocus
            type="cust"
            value={cust}
            onChange={(e) => setCust(e.target.value)}
          />
        </Form.Group>

        <Form.Group controlId="Listing Fees" className="mb-2 mt-2">
          <Form.Label className="control-label"> Listing Fees </Form.Label>
          <Form.Control
            autoFocus
            onWheel={disableScroll}
            name="listingFees"
            type="number"
            step={0.01}
            onChange={(e) => countTotalFees(e)}
          />
        </Form.Group>
        {checkNegativeValue.checkListingFees && (
          <Alert severity="error" className="pt-0 pl-0" >Please Enter Positive Value!</Alert>
        )}
        <Form.Group controlId="Marketplace Fee" className="mb-2 mt-2">
          <Form.Label className="control-label"> Marketplace Fee </Form.Label>
          <Form.Control
            autoFocus
            type="number"
            name="commision"
            onWheel={disableScroll}
            step={0.01}
            onChange={(e) => countTotalFees(e)}
          />
        </Form.Group>
        {checkNegativeValue.checkCommision && (
          <Alert severity="error" className="pt-0 pl-0">Please Enter Positive Value!</Alert>
        )}
        <Form.Group controlId="Shipping Fee" className="mb-2 mt-2">
          <Form.Label className="control-label"> Shipping Fee </Form.Label>
          <Form.Control
            autoFocus
            type="number"
            step={0.01}
            name="shippingFees"
            onWheel={disableScroll}
            onChange={(e) => countTotalFees(e)}
          />
        </Form.Group>
        {checkNegativeValue.checkShippingFees && (
          <Alert severity="error" className="pt-0 pl-0" >Please Enter Positive Value!</Alert>
        )}
        <Form.Group controlId="fee" className="form-group required mt-2">
          <Form.Label className="control-label">
            {" "}
            Total Fees $ (Listing Fee, Shipping, Marketplace Fee){" "}
          </Form.Label>
          <Form.Control
            autoFocus
            type="number"
            step={0.01}
            placeholder="0.00"
            value={(totalFees >= 0 && !isFeeChange) ? totalFees : ( isOpen ? allFeeTotal : "" ) }
            onWheel={disableScroll}
            onChange={(e) => {
              setIsFeeChange(false);
              handleChange(e,"fee")
          }}
          />
        </Form.Group>

        <Form.Group controlId="note">
          <Form.Label> Note (ex: Order Number) </Form.Label>
          <Form.Control
            autoFocus
            type="note"
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
        </Form.Group>
        <Button
          block
          size="sm"
          type="submit"
          disabled={!validateForm()}
          className="modal-add-button"
        >
          {loading ?
            <><CircularProgress className="file-loader mr-3" /> Add Sale </>
            : 'Add Sale'
          }
        </Button>
      </Form>
    </>
  );
}
export default SPopup;
